module.exports = __webpack_public_path__ + "img/nanny-cover1.2cad1630.jpg";